import React, { useEffect, useState } from "react";
import {
	Show,
	DateField,
	ReferenceField,
	SimpleShowLayout,
	TextField,
	NumberField,
	useDataProvider,
	useRecordContext,
} from "react-admin";
import ErrorIcon from "@mui/icons-material/Error";
import { Typography, LinearProgress  } from "@mui/material";

const UserField = () => {
	const record = useRecordContext();
	const dataProvider = useDataProvider();
	const [user, setUser] = useState();
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState();

	useEffect(() => {
		dataProvider
			.getOne("user", { where: { uid: { _eq: record.user_uid } } })
			.then(({ data }) => {
				setUser(data);
				setLoading(false);
			})
			.catch((error) => {
				setError(error);
				setLoading(false);
			});
	}, []);

	if (loading) return <LinearProgress />;
	if (error)
		return (
			<ErrorIcon
				aria-errormessage={error.message ? error.message : error}
				role="presentation"
				color="error"
				fontSize="small"
			/>
		);
	if (!user) return null;

	return (
		<Typography component="span" variant="body2">
			{user.email}
		</Typography>
	);
};

const FundraisersCampaignShow = (props) => (
	<Show {...props}>
		<SimpleShowLayout>
			<NumberField source="id" label="Id" />
			<TextField source="description" label="Titre" />
			<ReferenceField
				label="Campagne"
				source="campaign_id"
				reference="campaign"
				basePath="/campaign"
				link="show"
			>
				<TextField source="abstract_title" />
			</ReferenceField>
			<TextField source="amount" label="Objectif" />
			<UserField label="Créateur" />
		</SimpleShowLayout>
	</Show>
);

export default FundraisersCampaignShow;
